// this is an autogenerated file from App/Account/Content/Settings/Content/CommsSettings/Settings/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_CommsSettings_Settings($location_id: uuid!) {
  comms_settings(where: { location_id: { _eq: $location_id } }) {
    id
    sending_window
    flags
  }
}

`